// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11wIM","questions":"styles_questions__3AbW2","footer":"styles_footer__3bGQt"};